export default [{
    path: '/alerting',
    component: () => import('../pages/incidents/Index.vue'),
    children: [
        {
            path: '',
            name: 'incidents/summary',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [{ label: 'Alerting' }],
            },
            component: () => import('../pages/incidents/AlertingSummary.vue'),
        },
        {
            path: 'all',
            name: 'incidents/list',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [{ label: 'Alerting', to: { name: 'incidents/summary' } }, { label: 'All Incidents' }],
            },
            component: () => import('../pages/incidents/Incidents.vue'),
        },
        {
            path: 'incident/:id',
            name: 'incidents/detail',
            meta: {
                parentPath: '/alerting',
                layout: 'default',
                breadcrumb: [{ label: 'Alerting', to: { name: 'incidents/summary' } }, { label: 'Incident Detail' }],
            },
            component: () => import('../pages/incidents/IncidentDetail.vue'),
        },
    ],
}];
